import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class BarraDateParserFormatter extends NgbDateParserFormatter {
    private readonly DELIMITADOR = "/";

    parse(fecha: string): NgbDateStruct | null {
        console.log(fecha);
        if (fecha) {
            const fechaSplitBarra = fecha.split(this.DELIMITADOR);
            return {
                day: parseInt(fechaSplitBarra[0], 10),
                month: parseInt(fechaSplitBarra[1], 10),
                year: parseInt(fechaSplitBarra[2], 10)
            };
        }
        return null;
    }

    format(fecha: NgbDateStruct | null): string {
        return fecha ? fecha.day + this.DELIMITADOR + fecha.month + this.DELIMITADOR + fecha.year : "";
    }
}
